// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ea9f81e2","759":"b2093caf"}[chunkId] + ".chunk.js";
};